import { supabase } from '../supabaseClient';
import { throttleSupabaseQuery } from '../../utils/requestThrottler';

export class ContentService {
  // TRANSLATIONS MANAGEMENT
  static async getTranslationCategories() {
    try {
      const { data, error } = await supabase
        .from('translation_categories')
        .select('*')
        .order('category_key');

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching translation categories:', error);
      throw error;
    }
  }

  static async getTranslationKeys(categoryId) {
    try {
      const { data, error } = await supabase
        .from('translation_keys')
        .select(`
          *,
          translations(*, languages(code, name, native_name))
        `)
        .eq('category_id', categoryId)
        .order('key_name');

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching translation keys:', error);
      throw error;
    }
  }

  static async createTranslationKey(keyData) {
    try {
      const { data, error } = await supabase
        .from('translation_keys')
        .insert([keyData])
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error creating translation key:', error);
      throw error;
    }
  }

  static async updateTranslation(id, languageId, translatedValue) {
    try {
      const { data, error } = await supabase
        .from('translations')
        .upsert({
          key_id: id,
          language_id: languageId,
          translated_value: translatedValue,
          needs_review: false
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error updating translation:', error);
      throw error;
    }
  }

  static async bulkUpdateTranslations(translations) {
    try {
      const { data, error } = await supabase
        .from('translations')
        .upsert(translations)
        .select();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error bulk updating translations:', error);
      throw error;
    }
  }

  // Throttled version of getTranslationCategories
  static async getTranslationCategoriesThrottled() {
    return throttleSupabaseQuery(
      async () => {
        const { data, error } = await supabase
          .from('translation_categories')
          .select('*')
          .order('category_key');

        if (error) throw error;
        return data;
      },
      'get_translation_categories',
      {
        retries: 2,
        useCache: true,
        cacheTimeout: 5 * 60 * 1000 // 5 minutes
      }
    );
  }
}
